export default function programation() {
    if(document.querySelector(".programation__items")) {
        let programationDays = document.querySelectorAll(".programation__day--tv");
        let programationDaysRadio = document.querySelectorAll(".programation__day--radio");

        programationDays.forEach(day => {
            day.addEventListener("click", () => {
                programationDays.forEach(day => day.classList.remove("active"));

                day.classList.add("active");
            });
        });

        programationDaysRadio.forEach(day => {
            day.addEventListener("click", () => {
                programationDaysRadio.forEach(day => day.classList.remove("active"));

                day.classList.add("active");
            });
        });
    }
}